import powerUpSounds from './power_up/'
import warningSounds from './warning/'
import eatingSounds from './eating/'
import powerDownSounds from './power_down/'

export const sounds = {
  powerUp: powerUpSounds,
  warning: warningSounds,
  eating: eatingSounds,
  powerDown: powerDownSounds,
}



// WEBPACK FOOTER //
// ./client/components/sounds/index.js